import React from 'react';
import {
    Chip,
    Link,
    Stack,
    Typography,
} from '@mui/material';
import {useNavigate} from 'react-router';

function fitChip(fintel) {
    if (fintel.fit === 'full' || fintel.fitLabel === 'Fully Answers') {
        return <Chip size="small" color="success" label="Fully Answers" sx={{height: 22}}/>;
    }
    if (fintel.fit === 'partial' || fintel.fitLabel === 'Partially Answers') {
        const pct = Math.round(fintel.qualityScore ?? fintel.answerPct ?? 0);
        return (
            <Chip
                size="small"
                color="warning"
                label={`Partially Answers (${pct}%)`}
                sx={{height: 22}}
            />
        );
    }
    if (!fintel.linked) {
        const pct = Math.round(fintel.qualityScore ?? fintel.relevancePct ?? 0);
        return (
            <Chip
                size="small"
                variant="outlined"
                label={pct > 0 ? `Suggested (${pct}%)` : 'Suggested'}
                sx={{height: 22}}
            />
        );
    }
    return <Chip size="small" variant="outlined" label="Linked" sx={{height: 22}}/>;
}

/**
 * FINTEL product evidence row inside an Analytics pane.
 * Titles navigate to the product preview; AR text is never shown.
 */
export default function FintelProductRow({fintel}) {
    const navigate = useNavigate();
    const title = fintel.reportTitle || fintel.title || 'Untitled FINTEL';
    const excerpt = String(fintel.answerExcerpt || fintel.answerText || '').trim();
    const hideExcerpt = /^factual\s+\d+%\s*\/\s*opinion\s+\d+%$/i.test(excerpt);

    return (
        <Stack
            spacing={0.75}
            sx={{
                p: 1.25,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                bgcolor: 'background.paper',
            }}
            onClick={(event) => event.stopPropagation()}
        >
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap>
                {fitChip(fintel)}
                {fintel.reportId ? (
                    <Link
                        component="button"
                        type="button"
                        variant="body2"
                        underline="hover"
                        onClick={() => navigate(
                            `/products/${encodeURIComponent(fintel.reportId)}/preview`,
                        )}
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            fontWeight: 700,
                            textAlign: 'left',
                        }}
                        title={title}
                    >
                        {title}
                    </Link>
                ) : (
                    <Typography variant="body2" fontWeight={700} noWrap title={title} sx={{flex: 1, minWidth: 0}}>
                        {title}
                    </Typography>
                )}
            </Stack>
            {excerpt && !hideExcerpt ? (
                <Typography variant="caption" color="text.secondary" sx={{lineHeight: 1.45}}>
                    {excerpt}
                </Typography>
            ) : null}
        </Stack>
    );
}
